
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/parts/all_category",
      function () {
        return require("private-next-pages/parts/all_category.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/parts/all_category"])
      });
    }
  